const testimonialData = {
  stackText: 'TESTIMONIOS',
  titleText: 'Lo que dicen nuestros clientes',
  subtitleText: 'Descubre cómo Fingo ha transformado negocios con su integración fluida, diseño intuitivo y potentes funcionalidades que simplifican la gestión financiera.',
  testimonials: [
    {
      image: '/logos/comercializadora_yahve_herrera.webp',
      company: 'Comercializadora yahve herrera',
      description: '“Lo que más valoro de Fingo es la rapidez con que responden y resuelven todo. Siempre cumplen con mis expectativas.”',
    },
    {
      image: '/logos/gys_spa.webp',
      company: 'Comercializadora GyS Spa',
      description: '“Fingo combina rapidez en la evaluación de facturas con precios competitivos. Vale la pena considerarlos como opción: más de la mitad de mis operaciones son con ellos.”',
    },
    {
      image: '/logos/empresa_personal_jcsc.webp',
      company: 'Empresa personal Juan Carlos Sandoval Carrasco',
      description: '“Siempre reciben mis consultas con respuestas rápidas y claras. Son eficientes y directos en todo momento.”',
    },
    {
      image: '/logos/deproming_spa.webp',
      company: 'DEPROMING SPA',
      description: '“Sus ejecutivos brindan una excelente asesoría. Sin duda, los considero una muy buena alternativa financiera para cualquier empresa que busque liquidez y soluciones flexibles para manejar su flujo de caja.”',
    },
    {
      image: '/logos/leonora_sistemas.webp',
      company: 'Leonora Sistemas S.A.',
      description: '“Nos gusta mucho la plataforma, que nos permite operar prácticamente de forma autónoma y tener toda la información siempre a la vista. Además, las notificaciones por WhatsApp son muy útiles, incluso para iniciar una operación directamente desde el mensaje. Si quieres evaluar facturas y operar con tranquilidad, no dudes en trabajar con Fingo.”',
    },
    {
      image: '/logos/vr_home_spa.webp',
      company: 'V&R Home Spa',
      description: '“Destaco la rapidez de gestión y ayuda de mi ejecutiva, la facilidad para operar en la web y que las transferencias llegan muy rápido. Les recomiendo probar Fingo: encontré mejores tasas que en otros servicios, y todo es muy simple, rápido y amigable. Además, ojalá tengan la suerte de contar con mi ejecutiva, que siempre responde cualquier duda o necesidad en tiempo y forma.”',
    },
    {
      image: '/logos/constructora_los_robles.webp',
      company: 'Constructora Los Robles S.A.',
      description: '“Destaco la agilidad de mi ejecutivo, las buenas tasas y la rapidez en los pagos. Sin dudarlo, recomiendo operar con Fingo.”',
    },
    {
      image: '/logos/comercial_el_llano.webp',
      company: 'Comercial el llano',
      description: '“Valoro la rapidez del servicio y la excelente atención de mi ejecutivo”',
    },
    {
      image: '/logos/md_capacitaciones_y_producciones.webp',
      company: 'M&D CAPACITACIONES Y PRODUCCIONES',
      description: '“Destaco la rapidez y la comunicación eficaz y amena con el ejecutivo.”',
    },
    {
      image: '/logos/flores_y_almacigos.webp',
      company: 'Flores y Almácigos Tere E SPA',
      description: '“Destaco la rapidez de las operaciones y la excelente atención del ejecutivo. Los trámites son mucho más simples gracias a la plataforma online, que te permite llevar el control de tus operaciones y conocer al instante el estado de pago de tus clientes. Además, el horario de atención es más amplio que el de los bancos, lo que permite obtener resultados al cierre de la jornada extendida.”',
    },
  ],
};

export default testimonialData;
